// Re-export the ApiError class for external use
export { ApiError } from './ApiError'

// Import all modules
import * as adminModule from './admin'
import * as authModule from './auth'
import * as bindersModule from './binders'
import * as buylistModule from './buylist'
import * as cardsModule from './cards'
import * as collectionModule from './collection'
import * as dashboardModule from './dashboard'
import * as decksModule from './decks'
import * as featuresModule from './features'
import * as feedbackModule from './feedback'
import * as filtersModule from './filters'
import * as notificationsModule from './notifications'
import * as playsetModule from './playset'
import * as pushSubscriptionsModule from './pushSubscriptions'
import * as sealedModule from './sealed'
import * as selllistModule from './selllist'
import * as subscriptionsModule from './subscriptions'
import * as userQuantitiesModule from './userQuantities'

// Create the unified API client object
export const api = {
  // Auth
  ...authModule,

  // Cards
  ...cardsModule,

  // Collection
  ...collectionModule,

  // User Filters
  ...filtersModule,

  // Buylist
  ...buylistModule,

  // Selllist
  ...selllistModule,

  // Decks
  ...decksModule,

  // Binders
  ...bindersModule,

  // Sealed Products
  ...sealedModule,

  // Notifications
  ...notificationsModule,

  // Admin
  ...adminModule,

  // Features
  ...featuresModule,

  // User Quantities (combined)
  ...userQuantitiesModule,

  // Dashboard (combined)
  ...dashboardModule,

  // Subscriptions
  ...subscriptionsModule,

  // Push Subscriptions
  ...pushSubscriptionsModule,

  // Feedback
  ...feedbackModule,

  // Playset
  ...playsetModule,
}
